<div class="container content-cart" style="background: #e2e4e6b7;">
    <div class="header-promotion">
        <div class="row pt-2 no-gutters">
            <div class="col-1">
                <button type="button" (click)="onBackClick()"
                    class="btn-circle-home dropdown-toggle text-white border-0 outline-0 box-shadow-none mt-2">
                    <i class="fas fa fa-chevron-left" style="font-size: 15px !important;"></i>
                </button>
            </div>
            <div class="col text-center mt-1 border-bottom mx-2">
                <div style="border-radius: 10px !important;height: 40px !important;" (click)="onPromotionsClick('PROMOS')" class="border cursor p-1"
                    [ngClass]="{'badge-secondary' : !promos, 'badge-info' : promos }">
                    <span style="position: absolute;top: 9px;right: 38%;">Promos</span>
                </div>
            </div>
            <div class="col text-center mt-1 mr-2 border-bottom">
                <div style="border-radius: 10px !important;height: 40px !important;" (click)="onPromotionsClick('VOUCHERS')" class="border cursor p-1"
                    [ngClass]="{'badge-secondary' : !vouchers, 'badge-info' : vouchers }">
                    <span style="position: absolute;top: 9px;right: 38%;">Vouchers</span>
                </div>
            </div>
            <div class="col-1"></div>
        </div>
    </div>
    <div class="body-promotion">
        <div *ngIf="promotionType === 'PROMOS'">
            <div class="row">
                <div class="col text-center">
                    <span style="color: blue;">Promotions applied automatically before payments</span>
                </div>
            </div>
            <div class="row" *ngIf="promosList.length === 0">
                <div class="col border border-dark text-center p-2">
                    <span class="text-danger">No promos found</span>
                </div>
            </div>
            <div class="row" *ngFor="let promo of promosList" style="margin-bottom:-10px">
                <div class="col border m-2 p-2 bg-white">
                    <div style="min-height: 65px;">
                        <div [innerHTML]="promo.mod_description"></div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="promotionType === 'VOUCHERS'">
            <div class="row">
                <div class="col-1"></div>
                <div class="col text-center">
                    <span style="color: blue;">Only one Voucher is applied at a time</span>
                </div>
                <div class="col-2"></div>
            </div>
            <div class="row ">
                <div class="col-1"></div>
                <div class="col">
                    <div class="form-floating" [formGroup]="promoCodeForm">
                        <input type="text" class="form-control form-control-lg" id="voucher" formControlName="promocode"
                            placeholder="Enter your voucher code here"
                            [ngClass]="{'has-error': ((promoCodeForm.get('promocode').touched || promoCodeForm.get('promocode').dirty) &&  promoCodeForm.get('promocode').errors)}" />
                        <label for="voucher" class="text-danger">{{promoError}}</label>
                    </div>
                </div>
                <div class="col-2 mt-2">
                    <span class="text-primary text-right cursor"
                        (click)="onApplyPromoCodeClick('VOUCHERS',promoCodeForm.controls['promocode'].value)">Apply</span>
                </div>
                <div class="col-1"></div>
            </div>
            <div class="row " *ngFor="let voucher of vouchersList">
                <div class="col border m-2 p-2 bg-white" >
                    <div>
                        <span class="font-weight-bold">{{voucher.VoucherCode}}</span>
                    </div>
                    <div [innerHTML]="voucher.VoucherDescription">
                        <!--<span>{{voucher.VoucherDescription}}</span>-->
                    </div>
                    <div class="row">
                        <div class="col text-right">
                            <span class="text-primary text-right cursor"
                                (click)="onApplyPromoCodeClick('VOUCHERS',voucher.VoucherCode)">Apply</span>
                        </div>
                    </div>
                </div>
            </div>

                    <!--</div>-->
                    <!--<div>-->
                        <!--<span>Ahh yum offers 15% additional discount if you are paying with CIMB card.-->
                            <!--Enter  promo code <b>CIMB15</b> above and press Apply  </span>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
                        <!--&lt;!&ndash;<div class="col text-right">&ndash;&gt;-->
                            <!--&lt;!&ndash;<span class="text-primary text-right cursor"&ndash;&gt;-->
                                  <!--&lt;!&ndash;(click)="onApplyPromoCodeClick('VOUCHERS',voucher.VoucherCode)">Apply</span>&ndash;&gt;-->
                        <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="row " *ngIf="vouchersList.length > 0">-->
                <!--<div class="col border m-2 p-2 bg-white">-->
                    <!--<div>-->
                        <!--<span class="font-weight-bold">OLAR10</span>-->
                    <!--</div>-->
                    <!--<div>-->
                        <!--<span>All other Restaurants, Enjoy 10% additional using CIMB card.-->
                            <!--Enter <b>OLAR10</b> above and press apply  </span>-->
                        <!--<br/>-->
                        <!--<small>T&C Apply</small>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
                        <!--&lt;!&ndash;<div class="col text-right">&ndash;&gt;-->
                            <!--&lt;!&ndash;<span class="text-primary text-right cursor"&ndash;&gt;-->
                                  <!--&lt;!&ndash;(click)="onApplyPromoCodeClick('VOUCHERS',voucher.VoucherCode)">Apply</span>&ndash;&gt;-->
                        <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--</div>-->
            <!--</div>-->
            <div class="row" *ngIf="vouchersList.length === 0">
                <div class="col-1"></div>
                <div class="col text-center">
                    <span class="text-danger">No vouchers to show</span>
                </div>
                <div class="col-2"></div>
            </div>
        </div>
    </div>

</div>